import { now } from "@messages/timing";
export const applyDefaults = (defaults, overrides) => {
    return Object.assign(Object.assign({}, defaults), overrides);
};
/**
 * If not specified, then this messaging will be used, effectively sets broadcast to true and the rest to false
 */
export const DEFAULT_MESSAGING = {
    broadcast: true,
    local: false,
    peer: false,
    server: false,
};
/**
 * Shorthand to forbid sending of messages. Effectively sets `broadcast`, `local`, `peer` and `server` to false
 */
export const NO_MESSAGING = {
    broadcast: false,
    local: false,
    peer: false,
    server: false,
};
/**
 * Shorthand to only sending messages within this worker thread. Effectively sets all except for `local` to false
 */
export const LOCAL_MESSAGING = {
    broadcast: false,
    local: true,
    peer: false,
    server: false,
};
const compareMessagingProps = (props, otherProps) => {
    if (props === undefined)
        return false;
    return Object.entries(DEFAULT_MESSAGING).every(defaultEntry => {
        var _a, _b;
        const name = defaultEntry[0];
        const defaultValue = defaultEntry[1];
        const thisValue = (_a = props[name]) !== null && _a !== void 0 ? _a : defaultValue;
        const otherValue = (_b = otherProps[name]) !== null && _b !== void 0 ? _b : defaultValue;
        return thisValue === otherValue;
    });
};
/**
 * Is true if this BroadcastProps object specifies the same state as NO_MESSAGING
 */
export const isNoMessaging = (props) => {
    return compareMessagingProps(props, NO_MESSAGING);
};
/**
 * Helper function that determines whether a message should be created in any of the setter functions of model
 * as well as createModel, cloneModel, destroyModel etc. This functions returns true if any of broadcast, server or
 * peer are set to true in the BroadcastProps
 */
export const shouldBroadcast = (props) => {
    var _a, _b, _c, _d;
    const shouldBroadcast = (_a = props === null || props === void 0 ? void 0 : props.broadcast) !== null && _a !== void 0 ? _a : true;
    const sentLocal = (_b = props === null || props === void 0 ? void 0 : props.local) !== null && _b !== void 0 ? _b : false;
    const sentToPeer = (_c = props === null || props === void 0 ? void 0 : props.peer) !== null && _c !== void 0 ? _c : false;
    const sendToServer = (_d = props === null || props === void 0 ? void 0 : props.server) !== null && _d !== void 0 ? _d : false;
    return shouldBroadcast || sentLocal || sentToPeer || sendToServer;
};
/**
 * Either uses the MessageMetaData provided from message handlers are creates dummy metadata
 */
export const resolveMetaData = (metaData) => {
    if (metaData === undefined)
        return {
            source: { workerId: "", moduleId: "" },
            timeStamp: now(),
            clientId: "",
            transport: "normal"
        };
    else
        return metaData;
};
/**
 * Guards the emit check, resolves metadata, and either invokes fn immediately or defers it via queueMicrotask.
 * Replaces the repeated emitEvent + resolveMetaData + optional defer pattern at every invoke call site.
 */
export const emitOrDefer = (props, fn) => {
    if ((props === null || props === void 0 ? void 0 : props.emitEvent) === false)
        return;
    const metaData = resolveMetaData(props === null || props === void 0 ? void 0 : props.metaData);
    if ((props === null || props === void 0 ? void 0 : props.defer) === true)
        queueMicrotask(() => fn(metaData));
    else
        fn(metaData);
};
export const DefaultTransformProps = {
    updateFacet: true,
    sendBothFacetAndMessage: false,
    handleDescendantTransforms: true,
};
